import {ChargingPaymentMethodInterface} from '../interfaces/charging-payment-method.interface';

export class SetTeamSubscriptionPaymentMethodAction {
  static readonly type = '[Payment] Set team subscription payment method';

  constructor(public paymentMethod: ChargingPaymentMethodInterface) {
  }
}
